import { useMutation, useQueryClient } from "@tanstack/react-query";
import { terminalInventoryKeys } from "Api/Queries/TerminalInventory/useTerminalInventoryListQuery";
import {
  type ApiProblemDetails,
  type FetchResponse,
  putTerminalInventoryPublicID,
  type UpdateTerminalInventoryItemRequest,
} from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

type UpdateTerminalVariables = {
  publicID: string;
  request: UpdateTerminalInventoryItemRequest;
};

// 409 = duplicate serial number.
type UpdateTerminalInventoryItemError = FetchResponse<
  ApiProblemDetails,
  404 | 409
>;

type Props = {
  onSuccess?: () => void;
  onError?: (error: UpdateTerminalInventoryItemError) => void;
};

export const useUpdateTerminalInventoryItemMutation = ({
  onSuccess,
  onError,
}: Props = {}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: processResponseWithApiProblemDetails(
      ({ publicID, request }: UpdateTerminalVariables) =>
        putTerminalInventoryPublicID(request, publicID),
    ),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: terminalInventoryKeys.all });
      onSuccess?.();
    },
    onError,
  });
};
